// Share one concurrency limit across prefetch, expansions and refreshes.
export function createReadQueue({ concurrency = 2, hidden = () => document.hidden } = {}) {
  let active = 0;
  const pending = [];
  function pump() {
    if (hidden()) return;
    while (active < concurrency && pending.length) {
      pending.sort((a, b) => b.priority() - a.priority());
      const entry = pending.shift();
      entry.signal?.removeEventListener('abort', entry.cancel);
      if (entry.signal?.aborted) { entry.cancel(); continue; }
      active++;
      Promise.resolve().then(entry.read).then(entry.resolve, entry.reject).finally(() => { active--; pump(); });
    }
  }
  return {
    run(read, { signal, priority = () => 0 } = {}) {
      return new Promise((resolve, reject) => {
        const entry = { read, signal, priority, resolve, reject };
        entry.cancel = () => { const index = pending.indexOf(entry); if (index >= 0) pending.splice(index, 1); reject(new DOMException('Aborted', 'AbortError')); };
        if (signal?.aborted) return entry.cancel();
        pending.push(entry); signal?.addEventListener('abort', entry.cancel, { once: true }); pump();
      });
    },
    visibilityChanged: pump
  };
}
